webpackJsonp([120061014100915],{

/***/ 481:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulMember":{"name":"Kristine Jane Atienza","designation":"Co-Founder","thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/2tzy61o2N2KeUIy4uCo6QW/7786adb40076d3cc60269eb202b8d0e2/Tin.jpg"}},"content":{"content":"![blogMSA007A](//images.contentful.com/1o5ly3na7qu2/5wjaJfZWUguIOEgKO86eKe/a5afc3f9840f5f55aafb53461d7b541a/blogMSA007A.JPG)\n\n__Kristine Jane Atienza__\n- MSA Co-Founder\n- Founder, Philippine Union of Student Organizations for Astronomy\n- Alumni, UP Astronomical Society"}}},"pathContext":{"id":"c7L8bfurRfimiqIeWeskUQM"}}

/***/ })

});


// WEBPACK FOOTER //
// path---member-kristine-jane-atienza-3380c8132750106a9742.js